import React from 'react';
import {Target, Globe} from 'lucide-react';
import './About.css';

const About = () => {
  return (
    <div className="about">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <div className="about-hero-content">
            <div className="about-hero-text">
              <h1>About Kenny Miles Exchange</h1>
              <p>
                Founded by visionary CEO Kenny Miles, our exchange represents the future of 
                cryptocurrency trading. We combine cutting-edge technology with unwavering commitment 
                to security and user experience in the digital asset space.
              </p>
            </div>
            <div className="about-hero-image">
              <img src="/KM22.jpg" alt="Kenny Miles Exchange Logo" />
            </div>
          </div>
        </div>
      </section>

      {/* CEO Section */}
      <section className="section">
        <div className="container">
          <div className="ceo-section">
            <div className="ceo-image">
            </div>
            <div className="ceo-content">
              <h2>Kenny Miles</h2>
              <h3>Founder & CEO</h3>
              <p>
                Kenny Miles is a visionary entrepreneur and cryptocurrency expert with over 7 years 
                of experience in digital assets and blockchain technology. His passion for innovation and commitment 
                to excellence has driven Kenny Miles Exchange to become one of the most 
                trusted names in cryptocurrency trading.
              </p>
              <p>
                Under Kenny's leadership, our exchange has grown from a startup to a global 
                platform serving thousands of users worldwide. His vision extends beyond 
                traditional trading - Kenny believes in democratizing access to cryptocurrency markets 
                and empowering individuals to take control of their digital financial future.
              </p>
              <div className="ceo-stats">
                <div className="stat">
                  <span className="stat-number">7+</span>
                  <span className="stat-label">Years Experience</span>
                </div>
                <div className="stat">
                  <span className="stat-number">1.5K+</span>
                  <span className="stat-label">Users Served</span>
                </div>
                <div className="stat">
                  <span className="stat-number">$10K+</span>
                  <span className="stat-label">Trading Volume</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="section bg-light">
        <div className="container">
          <div className="mission-vision-grid">
            <div className="mission-card">
              <Target className="card-icon" />
              <h3>Our Mission</h3>
              <p>
                To democratize access to cryptocurrency markets by providing a secure, 
                transparent, and user-friendly trading platform that empowers individuals 
                to achieve their digital asset goals with affordability they can trust.
              </p>
            </div>
            <div className="vision-card">
              <Globe className="card-icon" />
              <h3>Our Vision</h3>
              <p>
                To become the world's most trusted and innovative cryptocurrency trading platform, 
                setting new standards for security, transparency, and user experience 
                in the digital asset industry.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;